<template>
  <div class="row g-4">
    <div class="col-12">
      <div class="alert alert-info border-0 mb-0">
        <span class="badge text-bg-light border mb-3 px-3 py-2">Schritt 1</span>
        <div class="fw-semibold mb-2">Angaben zur Organisation</div>
        <div class="small text-body mb-0">
          Bitte geben Sie zuerst die Daten Ihrer Organisation ein. Eine Organisation kann ebenso ein Unternehmen wie eine Privatperson sein. An diese Anschrift adressieren wir z.B. Rechnungen. Sie ist nicht öffentlich.
          Den Standort Ihres Vermarktungsobjektes können Sie zu einem späteren Zeitpunkt separat wählen.
        </div>
      </div>
    </div>

    <div class="col-12">
      <label for="survey-name" class="form-label">Name der Organisation</label>
      <Field
        id="survey-name"
        name="name"
        type="text"
        v-model="surveyStore.data.name"
        class="form-control"
        :class="{'is-invalid': errors.name}"
        autocomplete="name"
      />
      <div v-if="errors.name" class="invalid-feedback d-block">
        {{ errors.name }}
      </div>
    </div>

    <div class="col-12">
      <label for="survey-phone" class="form-label">Telefon (optional)</label>
      <Field
        id="survey-phone"
        name="phone"
        type="tel"
        v-model="surveyStore.data.phone"
        class="form-control"
        :class="{'is-invalid': errors.phone}"
        autocomplete="tel"
        aria-describedby="survey-phone-hint"
      />
      <div id="survey-phone-hint" class="form-text">
        Wenn Sie keine Telefonnummer angeben möchten, lassen Sie dieses Feld bitte leer.
      </div>
      <div v-if="errors.phone" class="invalid-feedback d-block">
        {{ errors.phone }}
      </div>
    </div>

    <div class="col-12">
      <h3 class="h5 mb-3">Adresse der Organisation</h3>
      <Address
        :errors="errors"
        v-model="surveyStore.data.address"
        field-prefix="address"
        :show-address-details="false"
      />
    </div>
  </div>
</template>

<script>
import {Field} from "vee-validate";
import {useSurveyStore} from "@/stores/survey";
import Address from "@/components/general/Address.vue";

export default {
  name: "ClientData",
  components: {
    Field,
    Address,
  },
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
}
</script>
